/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, HostBinding, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { CommunicationType } from '@gh/builder-shared-data';
import {
  createDialogRoute,
  FormState,
  FormStateBuilder,
  getDialogInitData,
  TextTypes,
  whenCreateOrEditMode,
} from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { TranslationService } from '@gh/core-mls';
import {
  AutocompleteLoadMoreEvent,
  DialogInput,
  DialogService,
  FormMode,
  getControlValue,
  NotificationService,
  responsiveDialogOverlayPaneClass,
  TinymceSettings,
  tmSettingsBuilder,
  WaitingService,
  yesAnswer,
  yesNoConfirmation,
} from '@gh/core-ui';
import { filter$ } from '@gh/rx/operators';

import { isEmpty } from 'lodash';
import { BuilderUserContext } from '../../../user';

import {
  CommunicationsBusinessService,
  EmailDialogConfig,
  isCreateEmailDialogConfig, WebsiteDialogConfig,
} from '../../resources/communications-business.service';
import {
  CommunicationListItem,
  EmailDetails,
  emailDetailsFromCommunicationItem,
  emailDetailsToCommunicationItem,
} from '../../resources/communications.model';

@Component({
  selector: 'gh-website-dialog',
  template: require('./website-dialog.component.html'),
})

export class WebsiteDialogComponent implements OnInit, DialogInput<WebsiteDialogConfig> {
  input: WebsiteDialogConfig;

  constructor(private formStateBuilder: FormStateBuilder,
              private userContext: BuilderUserContext,
              private businessService: CommunicationsBusinessService,
              private waitingService: WaitingService,
              public dialogRef: MatDialogRef<WebsiteDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private dialogData: any,
              private notificationService: NotificationService,
              private translationService: TranslationService,
              private dialogService: DialogService) {

  }

  ngOnInit(): void {
    const website = this.input.website;
    if (website && !website.communicationId && !website.isMarkedAsRead) {
      // tslint:disable-next-line:no-non-null-assertion
      this.businessService.readSms(website.communicationId!).pipe(
        this.waitingService.operator(),
      ).subscribe((response) => {
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}

export const websiteDialogRoute = createDialogRoute({
  component: WebsiteDialogComponent,
  config: {
    disableClose: true,
    maxHeight: '100vh',
    panelClass: responsiveDialogOverlayPaneClass(),
  },
});
